import React, { Component } from 'react';
import Icon from '../../icons';

class SelectSearch extends Component {
    selectedRef;
    menuRef;
    state = {   
        isOpen: false,
        searchText:"",
        menuOptions:[],
        selectedItem:0,
        isHovered: true,
    }

    componentDidMount() {
        document.addEventListener('mousedown', this.onClickOutsideSelect);
        this.setState({menuOptions :  this.props.options});
    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.onClickOutsideSelect);
    }

    onClickOutsideSelect = (e) => {
        if (this.menuRef && !this.menuRef.contains(e.target)) {
            this.closeDropDown();
        }
    }

    openDropDown = () => {
        this.setState({
            isOpen: true,
            menuOptions:this.props.options
        },() =>{
            if(this.menuRef.scrollTop === 0 && this.selectedRef){
                setTimeout(() => {
                    this.menuRef.scrollTop =this.selectedRef &&  this.selectedRef.getBoundingClientRect().top - this.menuRef.getBoundingClientRect().top
                }, 200);
            } else {
                $(".select2-results").scrollTop(0);
            }
        })
       
    }

    closeDropDown = () => {
        this.setState({
            isOpen: false,
            searchText: '',
            selectedItem:0
        })
    }
    
    onSearchText = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
            searchText: e.target.value
        })
        this.onSearch(e.target.value);
    }

    onSearch = (key) => { 
        if(key==="") {
            this.setState({menuOptions: this.props.options});
        } else {
           var filteredList =this.props.options.filter(option => option.DisplayName.toLowerCase().includes(key.toLowerCase()));
           this.setState({menuOptions: filteredList});
        }
    }

    onSelected = (option) => {
        if(!option.disabled) {
            if(this.props.selected !== option.Value) {
                this.props.onSelect(option);
            }
            this.closeDropDown();
        }
    }

    handleKeyDown = (e) => {
        if (e.keyCode === 40 || e.keyCode === 38) {
            let selector = this.props.Id, newSelected, listSize = this.state.menuOptions.length, list = this.state.menuOptions;
            
            newSelected = this.state.selectedItem;
            if (e.keyCode == 38) {   // Up
                newSelected = this.state.selectedItem === 0 ? 0 : this.state.selectedItem - 1;
            } else if (e.keyCode === 40) { // Down
                newSelected = this.state.selectedItem===listSize-1?listSize-1:(this.state.selectedItem + 1) % listSize;
            }
            this.setState({
                selectedItem: newSelected,
            });
            const Id = list[newSelected].Value;

            if (newSelected === listSize - 1) {                       //ending
                document.getElementById(Id).scrollIntoView();
                return;
            } else if (newSelected === 0) {
                document.getElementById(selector).scrollTo(0, 0);     //begining
                return;
            }

            const scrollTop = document.getElementById(selector).scrollTop;
            const selectedElementTop = document.getElementById(Id).offsetTop;
            const selectedElementHeight = document.getElementById(Id).offsetHeight;
            const scrollWindowHeight = document.getElementById(selector).offsetHeight;

            // no scroll if selected element top position and bottom position is inside the scroll window
            if (selectedElementTop > scrollTop + 80 && selectedElementTop + selectedElementHeight < scrollTop + scrollWindowHeight) {
                return;
            }
            if (e.keyCode == 38) {
                document.getElementById(selector).scrollBy(0, -selectedElementHeight)
            } else if (e.keyCode === 40) {
                document.getElementById(selector).scrollBy(0, selectedElementHeight)
            }
        }
        else if (e.keyCode === 13) {
            if (this.state.menuOptions.length > 0 && (this.state.selectedItem!=-1 || this.state.searchText.length > 0)) {
                const selectOption = this.state.menuOptions[this.state.selectedItem != -1 ? this.state.selectedItem : 0];
                this.onSelected(selectOption);
            }
        } else if(e.keyCode===9) {
            const selectOption = this.state.menuOptions[this.state.selectedItem != -1 ? this.state.selectedItem : 0];
                this.onSelected(selectOption);
                this.setState({isOpen:false});
        }
    }

    toggleHover =(e)=> {
        this.setState(prevState => ({
            isHovered: !prevState.isHovered,
            selectedItem:e
        }));
    }

    handleKeyDropDown =(e)=> {
        if(e.keyCode===40) {
            if(!this.state.isOpen){
                this.setState({isOpen:true,
                              menuOptions:this.props.options});
            }
        }
    }


    render() {
        const { Id,options, iconName, openOnHover, openOnClick, title , error} = this.props;
        const selected = options.find(option => option.Value== this.props.selected);

        return (
            <div tabIndex={0} onKeyDown={this.handleKeyDropDown}  className={`mailDropdown select ${error&&'errorState'}`}
                onMouseLeave={openOnHover ? this.closeDropDown : () => {}}>
                <div className="alignMiddle rowSpaceBetween flexGrow"
                    onClick={openOnClick ? (this.state.isOpen ? this.closeDropDown : this.openDropDown) : () => {}}
                    onMouseOver={openOnHover ? this.openDropDown : () => {}}>
                    { selected ? 
                        <span>{selected.DisplayName}</span> : 
                        title && <span>{ title}</span>
                    }
                    { iconName && <Icon name={iconName} className="icon ml select" />}
                </div>
                {this.state.isOpen &&
                <div ref={(node) => { this.menuRef = node }} className={`mailingSearch ${this.props.isOpenRight ? 'openRight' :''} openTop ${this.state.isOpen ? "onClick" : ''} `} >
                    <div className="sticky">
                        <input autoFocus={true} type="text"  onKeyDown={this.handleKeyDown} onChange={this.onSearchText} value={this.state.searchText} id={`${Id}InputBox`}   autoComplete="new-password" maxLength="200" autoCorrect="off" autoCapitalize="off"  />
                    </div>
                    <div className="select2-results" id={Id} >
                        {this.state.menuOptions && this.state.menuOptions.map((option, index) => (
                            <span
                                ref={(node) => { if(selected && option.Value === selected.Value) this.selectedRef = node}} 
                                onClick={(e) => { this.onSelected(option) }} 
                                key={index}
                            >
                                <a id={option.Value} onMouseEnter={ ()=>this.toggleHover(index)} onMouseLeave={()=>this.toggleHover(index)} 
                                    className={`pointer ${(this.state.selectedItem == index  ? 'activeElement':'' )} ${(selected && selected.Value == option.Value) ? 'active' : (option.disabled ? 'disabled' : '')}`} 
                                    >{option.DisplayName} {(selected && option.Value === selected.Value) && <span className="badges checked selectChecked green"></span>}
                                    </a>
                            </span>
                        ))}
                    </div>
                    {this.state.menuOptions.length<=0 && <span style={{paddingLeft:"12px"}}>No Records Found!</span> }
                </div>
                }
            </div>
        )
    }
}

export default SelectSearch;